// API Service - Central API configuration and HTTP client
import axios from 'axios';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token and active site header
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Attach user identity headers for endpoints that rely on them (messaging, chatbot)
    const userStr = localStorage.getItem('emr_user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user.id) config.headers['X-User-Id'] = user.id;
        if (user.role) config.headers['X-User-Role'] = user.role;
        if (user.name) config.headers['X-User-Name'] = user.name;
        if (user.patient_id) config.headers['X-Patient-Id'] = user.patient_id;
        if (user.tenant_id) config.headers['X-Tenant-Id'] = user.tenant_id;
        if (user.site_id) config.headers['X-Site-Id'] = user.site_id;
      } catch {}
    }
    // Attach the user's currently-selected site so the backend can scope queries
    const activeSiteId = localStorage.getItem('emr_active_site_id');
    if (activeSiteId) {
      config.headers['X-Site-Id'] = activeSiteId;
    }
    // SuperAdmin: scope requests to a specific tenant when impersonating a clinic
    const activeTenantId = localStorage.getItem('emr_active_tenant_id');
    if (activeTenantId) {
      config.headers['X-Tenant-Id'] = activeTenantId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Skip auto-logout for AI/agent/medscribe endpoints — let callers handle 401 gracefully
      const reqUrl = error.config?.url || '';
      const isAIEndpoint = /\/(ai|agents|medscribe|patient-ai|doctor|cds)\//i.test(reqUrl);
      if (!isAIEndpoint) {
        // Token expired or invalid - clear storage and redirect
        localStorage.removeItem('auth_token');
        localStorage.removeItem('emr_user');
        // Don't redirect if already on login page
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
